// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure pagination controls are always visible and scrollable on mobile/tablet */
@media (max-width: 900px) {
    .pagination {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch !important;
        flex-wrap: nowrap !important;
        justify-content: flex-start !important;
        padding-bottom: 8px !important;
        margin-bottom: 16px !important;
        background: #fff;
        border-radius: 8px;
    }
    .pagination-btn {
        min-width: 34px !important;
        width: 34px !important;
        height: 34px !important;
        font-size: 15px !important;
        margin-right: 4px !important;
    }
}
/* Distributors List Styles */

.distributor-form-group {
    margin-bottom: 20px;
}

.distributor-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    text-align: left;
}

.distributor-modal-footer {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;
}

.distributor-list-container {
    padding: 20px;
}

.distributor-header-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.distributor-add-btn {
    font-size: 16px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
}

.distributor-add-btn svg {
    margin-right: 8px;
}

.distributor-table-container {
    margin-top: 20px;
    overflow-x: auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    position: relative;
}

.distributor-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;
}

.distributor-table-head-tr {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.distributor-th {
    padding: 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    font-size: 14px;
}

.distributor-th-center {
    text-align: center;
}

.distributor-tr {
    border-bottom: 1px solid #dee2e6;
    transition: background-color 0.2s;
    cursor: pointer;
}

.distributor-tr:hover {
    background-color: #f8f9fa;
}

.distributor-td {
    padding: 16px;
    font-size: 14px;
    vertical-align: middle;
}

.distributor-td-img {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid #dee2e6;
}

.distributor-company-name {
    font-weight: 500;
    color: #212529;
}

.distributor-website-link {
    color: #0A4DA2;
    text-decoration: none;
}

.distributor-text-secondary {
    color: #495057;
}

.distributor-text-center {
    text-align: center;
}

.distributor-action-container {
    position: relative;
    display: inline-block;
}

.distributor-action-icon {
    cursor: pointer;
}

.distributor-dropdown-item {
    padding: 10px 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
}

.distributor-dropdown-item-delete {
    color: #dc3545;
}

.distributor-empty-state {
    text-align: center;
    padding: 40px;
    color: #6c757d;
}

.distributor-link {
    color: #007bff;
    text-decoration: none;
}

.distributor-link:hover {
    text-decoration: underline;
}

.distributor-status-badge {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
}

/* Responsive styles for distributor header actions and search field */
@media (max-width: 600px) {
    .distributor-header-actions {
        flex-direction: column !important;
        align-items: stretch !important;
        padding: 0 !important;
        gap: 8px !important;
        margin-bottom: 8px !important;
    }
    .distributor-header-actions input[type="text"] {
           width: 100% !important;
           min-width: 0 !important;
           font-size: 16px !important;
           margin-bottom: 0 !important;
           padding: 10px !important;
    }
    .distributor-header-actions select,
    .distributor-header-actions label {
        width: 100% !important;
        font-size: 16px !important;
    }
    .distributor-header-actions > div {
        width: 100% !important;
        justify-content: flex-start !important;
    }
    .distributor-search-wrap {
        flex: 1 1 auto !important;
        min-width: 0 !important;
    }
    .distributor-add-btn {
        width: fit-content !important;
        align-self: flex-start !important;
        margin: 0 !important;
    }
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
    .distributor-list-container {
        padding: 10px;
    }

    .distributor-add-btn {
        font-size: 14px;
        padding: 8px 16px;
    }

    .distributor-add-btn svg {
        margin-right: 6px;
        width: 18px;
        height: 18px;
    }

    .distributor-th {
        padding: 12px 8px;
        font-size: 12px;
    }

    .distributor-td {
        padding: 12px 8px;
        font-size: 13px;
    }

    .distributor-td-img {
        width: 40px;
        height: 40px;
    }

    .distributor-action-icon {
        width: 18px;
        height: 18px;
    }
}

/* Radio Button Styles (adapted for Distributors Modal) */
.radioBtns {
    display: flex;
    align-items: center;
}

.radio {
    margin: 1rem;
    position: relative;
}

.radio input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.radio-label {
    cursor: pointer;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.radio-label:before {
    content: "";
    background: #9a9a9a;
    border-radius: 100%;
    border: 1px solid #a2a2a9;
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-right: 0.5em;
    vertical-align: top;
    text-align: center;
    transition: all 250ms ease;
    flex-shrink: 0;
}

.radio input[type="radio"]:checked + .radio-label:before {
    background-color: #ffffff;
    box-shadow: inset 0 0 0 4px #004996;
    border-color: #004996;
}

.radio input[type="radio"]:focus + .radio-label:before {
    outline: none;
    border-color: #004996;
}

/* View Distributor Styles */
.view-distributor-container {
    padding: 20px;
    text-align: center;
}

.view-distributor-card {
    width: 100%;
    margin: 20px auto;
    padding: 30px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.view-distributor-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
}

.view-distributor-title {
    margin: 0;
    color: #333;
}

.view-distributor-back-btn {
    padding: 8px 16px;
    font-size: 14px;
}

.view-distributor-image-section {
    margin-bottom: 30px;
}

.view-distributor-avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    border: 3px solid #f0f0f0;
}

.view-distributor-grid {
    /* display: grid; */
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.view-field {
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.field-label {
    display: block;
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 4px;
    font-weight: 500;
}

.field-value {
    margin: 0;
    color: #212529;
    font-weight: 400;
    padding: 0px 8px;
    /* background-color: #f8f9fa; */
    border-radius: 6px;
    /* border: 1px solid #e9ecef; */
    min-height: 20px;
}

.view-distributor-status-badge {
    padding: 5px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 14px;
}

.status-active {
    /* background-color: #e6f7e9; */
    color: #28a745;
}

.status-inactive {
    /* background-color: #fbeaea; */
    color: #dc3545;
}

@media (max-width: 768px) {
    .view-distributor-card {
        padding: 15px !important;
    }
    .view-distributor-grid {
        grid-template-columns: 1fr !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/distributors.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;IACI;QACI,2BAA2B;QAC3B,4CAA4C;QAC5C,4BAA4B;QAC5B,sCAAsC;QACtC,8BAA8B;QAC9B,8BAA8B;QAC9B,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,0BAA0B;QAC1B,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;QAC1B,4BAA4B;IAChC;AACJ;AACA,6BAA6B;;AAE7B;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,sEAAsE;AACtE;IACI;QACI,iCAAiC;QACjC,+BAA+B;QAC/B,qBAAqB;QACrB,mBAAmB;QACnB,6BAA6B;IACjC;IACA;WACO,sBAAsB;WACtB,uBAAuB;WACvB,0BAA0B;WAC1B,2BAA2B;WAC3B,wBAAwB;IAC/B;IACA;;QAEI,sBAAsB;QACtB,0BAA0B;IAC9B;IACA;QACI,sBAAsB;QACtB,sCAAsC;IAC1C;IACA;QACI,yBAAyB;QACzB,uBAAuB;IAC3B;IACA;QACI,6BAA6B;QAC7B,iCAAiC;QACjC,oBAAoB;IACxB;AACJ;;AAEA,6BAA6B;AAC7B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":["/* Ensure pagination controls are always visible and scrollable on mobile/tablet */\n@media (max-width: 900px) {\n    .pagination {\n        overflow-x: auto !important;\n        -webkit-overflow-scrolling: touch !important;\n        flex-wrap: nowrap !important;\n        justify-content: flex-start !important;\n        padding-bottom: 8px !important;\n        margin-bottom: 16px !important;\n        background: #fff;\n        border-radius: 8px;\n    }\n    .pagination-btn {\n        min-width: 34px !important;\n        width: 34px !important;\n        height: 34px !important;\n        font-size: 15px !important;\n        margin-right: 4px !important;\n    }\n}\n/* Distributors List Styles */\n\n.distributor-form-group {\n    margin-bottom: 20px;\n}\n\n.distributor-label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n    text-align: left;\n}\n\n.distributor-modal-footer {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.distributor-list-container {\n    padding: 20px;\n}\n\n.distributor-header-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 20px;\n}\n\n.distributor-add-btn {\n    font-size: 16px;\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n}\n\n.distributor-add-btn svg {\n    margin-right: 8px;\n}\n\n.distributor-table-container {\n    margin-top: 20px;\n    overflow-x: auto;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    position: relative;\n}\n\n.distributor-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 800px;\n}\n\n.distributor-table-head-tr {\n    background-color: #f8f9fa;\n    border-bottom: 2px solid #dee2e6;\n}\n\n.distributor-th {\n    padding: 16px;\n    text-align: left;\n    font-weight: 600;\n    color: #495057;\n    font-size: 14px;\n}\n\n.distributor-th-center {\n    text-align: center;\n}\n\n.distributor-tr {\n    border-bottom: 1px solid #dee2e6;\n    transition: background-color 0.2s;\n    cursor: pointer;\n}\n\n.distributor-tr:hover {\n    background-color: #f8f9fa;\n}\n\n.distributor-td {\n    padding: 16px;\n    font-size: 14px;\n    vertical-align: middle;\n}\n\n.distributor-td-img {\n    width: 50px;\n    height: 50px;\n    border-radius: 8px;\n    object-fit: cover;\n    border: 1px solid #dee2e6;\n}\n\n.distributor-company-name {\n    font-weight: 500;\n    color: #212529;\n}\n\n.distributor-website-link {\n    color: #0A4DA2;\n    text-decoration: none;\n}\n\n.distributor-text-secondary {\n    color: #495057;\n}\n\n.distributor-text-center {\n    text-align: center;\n}\n\n.distributor-action-container {\n    position: relative;\n    display: inline-block;\n}\n\n.distributor-action-icon {\n    cursor: pointer;\n}\n\n.distributor-dropdown-item {\n    padding: 10px 16px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n}\n\n.distributor-dropdown-item-delete {\n    color: #dc3545;\n}\n\n.distributor-empty-state {\n    text-align: center;\n    padding: 40px;\n    color: #6c757d;\n}\n\n.distributor-link {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.distributor-link:hover {\n    text-decoration: underline;\n}\n\n.distributor-status-badge {\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    display: inline-block;\n}\n\n/* Responsive styles for distributor header actions and search field */\n@media (max-width: 600px) {\n    .distributor-header-actions {\n        flex-direction: column !important;\n        align-items: stretch !important;\n        padding: 0 !important;\n        gap: 8px !important;\n        margin-bottom: 8px !important;\n    }\n    .distributor-header-actions input[type=\"text\"] {\n           width: 100% !important;\n           min-width: 0 !important;\n           font-size: 16px !important;\n           margin-bottom: 0 !important;\n           padding: 10px !important;\n    }\n    .distributor-header-actions select,\n    .distributor-header-actions label {\n        width: 100% !important;\n        font-size: 16px !important;\n    }\n    .distributor-header-actions > div {\n        width: 100% !important;\n        justify-content: flex-start !important;\n    }\n    .distributor-search-wrap {\n        flex: 1 1 auto !important;\n        min-width: 0 !important;\n    }\n    .distributor-add-btn {\n        width: fit-content !important;\n        align-self: flex-start !important;\n        margin: 0 !important;\n    }\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 768px) {\n    .distributor-list-container {\n        padding: 10px;\n    }\n\n    .distributor-add-btn {\n        font-size: 14px;\n        padding: 8px 16px;\n    }\n\n    .distributor-add-btn svg {\n        margin-right: 6px;\n        width: 18px;\n        height: 18px;\n    }\n\n    .distributor-th {\n        padding: 12px 8px;\n        font-size: 12px;\n    }\n\n    .distributor-td {\n        padding: 12px 8px;\n        font-size: 13px;\n    }\n\n    .distributor-td-img {\n        width: 40px;\n        height: 40px;\n    }\n\n    .distributor-action-icon {\n        width: 18px;\n        height: 18px;\n    }\n}\n\n/* Radio Button Styles (adapted for Distributors Modal) */\n.radioBtns {\n    display: flex;\n    align-items: center;\n}\n\n.radio {\n    margin: 1rem;\n    position: relative;\n}\n\n.radio input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.radio-label {\n    cursor: pointer;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n}\n\n.radio-label:before {\n    content: \"\";\n    background: #9a9a9a;\n    border-radius: 100%;\n    border: 1px solid #a2a2a9;\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    margin-right: 0.5em;\n    vertical-align: top;\n    text-align: center;\n    transition: all 250ms ease;\n    flex-shrink: 0;\n}\n\n.radio input[type=\"radio\"]:checked + .radio-label:before {\n    background-color: #ffffff;\n    box-shadow: inset 0 0 0 4px #004996;\n    border-color: #004996;\n}\n\n.radio input[type=\"radio\"]:focus + .radio-label:before {\n    outline: none;\n    border-color: #004996;\n}\n\n/* View Distributor Styles */\n.view-distributor-container {\n    padding: 20px;\n    text-align: center;\n}\n\n.view-distributor-card {\n    width: 100%;\n    margin: 20px auto;\n    padding: 30px;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\n}\n\n.view-distributor-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 15px;\n}\n\n.view-distributor-title {\n    margin: 0;\n    color: #333;\n}\n\n.view-distributor-back-btn {\n    padding: 8px 16px;\n    font-size: 14px;\n}\n\n.view-distributor-image-section {\n    margin-bottom: 30px;\n}\n\n.view-distributor-avatar {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    background-size: cover;\n    background-position: center;\n    border: 3px solid #f0f0f0;\n}\n\n.view-distributor-grid {\n    /* display: grid; */\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n}\n\n.view-field {\n    margin-bottom: 5px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.field-label {\n    display: block;\n    font-size: 13px;\n    color: #6c757d;\n    margin-bottom: 4px;\n    font-weight: 500;\n}\n\n.field-value {\n    margin: 0;\n    color: #212529;\n    font-weight: 400;\n    padding: 0px 8px;\n    /* background-color: #f8f9fa; */\n    border-radius: 6px;\n    /* border: 1px solid #e9ecef; */\n    min-height: 20px;\n}\n\n.view-distributor-status-badge {\n    padding: 5px 12px;\n    border-radius: 20px;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.status-active {\n    /* background-color: #e6f7e9; */\n    color: #28a745;\n}\n\n.status-inactive {\n    /* background-color: #fbeaea; */\n    color: #dc3545;\n}\n\n@media (max-width: 768px) {\n    .view-distributor-card {\n        padding: 15px !important;\n    }\n    .view-distributor-grid {\n        grid-template-columns: 1fr !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
